export default "<h1 class=\"page-title\">Irish</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";